module.exports = __webpack_public_path__ + "static/media/ladder@3x.50f3effa.png";